// File size and format constants
export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
export const SUPPORTED_VIDEO_TYPES = ["video/mp4", "video/quicktime", "video/x-msvideo", "video/webm"];

// Frame extraction timestamps
export const FRAME_TIMESTAMPS = [1, 2.5, 5];
